import { createBrowserRouter } from 'react-router-dom';
import EmailVerificationPage from '../../../UI/Auth/EmailVerification.page';
import ForgotPasswordPage from '../../../UI/Auth/ForgotPassword.page';
import LoginPage from '../../../UI/Auth/Login.page';
import RegisterPage from '../../../UI/Auth/Register.page';
import ResetPasswordPage from '../../../UI/Auth/ResetPassword.page';
import { EntryPath } from './entry.path';
import EntryLayout from '@/Domain/components/App/Layout/EntryLayout';

export default createBrowserRouter([
  {
    path: '/',
    element: <EntryLayout />,
    children: [
      {
        index: true,
        element: <LoginPage />,
      },
      {
        path: EntryPath.forgetPassword,
        element: <ForgotPasswordPage />,
      },
      {
        path: EntryPath.register,
        element: <RegisterPage />,
      },
      {
        path: EntryPath.emailVerification,
        element: <EmailVerificationPage />,
      },
      {
        path: EntryPath.resetPassword,
        element: <ResetPasswordPage />,
      },
    ],
  },
]);
